import { useCallback, useState } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Dialog } from "@/components/ui/design-system";
import { useResource } from "@/components/workflow/shared";
import { SickLeaveCreateDialog } from "@/components/SickLeaveCreateDialog";
import { sickLeave, type SickLeaveWorker } from "@/lib/bolovanja";
import { useAuth } from "@/context/AuthContext";

interface WorkerListProps {
  siteId?: string; onChanged?: () => void; onClose?: () => void;
}
export function SickLeaveWorkerList(props: WorkerListProps) {
  const { user } = useAuth();
  return <WorkerListContent key={`${user?.id}:${JSON.stringify(user?.permissions)}:${props.siteId ?? "all"}`} {...props} />;
}
function WorkerListContent({ siteId, onChanged, onClose }: WorkerListProps) {
  const [selected, setSelected] = useState<SickLeaveWorker | null>(null);
  const resource = useResource(`sick-leave-workers:${siteId ?? "all"}`, useCallback(signal => sickLeave.workers(siteId, signal), [siteId]));
  const content = <section aria-label="Radnici za prijavu bolovanja" className="space-y-3">
    {resource.error && <p role="alert" className="text-red-800">{resource.error}<Button variant="outline" onClick={resource.reload}>Pokušaj ponovno</Button></p>}
    {resource.loading && <p role="status">Učitavanje radnika…</p>}
    {!resource.loading && !resource.error && !resource.data?.length && <p>Nema radnika na vašim gradilištima za danas.</p>}
    {resource.data?.map(worker => <article key={`${worker.gradiliste_id}:${worker.radnik_id}`} className={`flex flex-wrap items-center justify-between gap-3 rounded-lg border p-4 ${worker.na_bolovanju ? "border-red-300 bg-red-50" : ""}`}>
      <div><h2 className="font-semibold">{worker.worker_name}</h2><p className="text-sm">{worker.site_name}</p>{worker.na_bolovanju && <Badge ton="bad">Na bolovanju</Badge>}</div>
      {!worker.na_bolovanju && <Button className="min-h-11" variant="outline" onClick={() => setSelected(worker)}>Bolovanje · {worker.worker_name}</Button>}
    </article>)}
  </section>;
  if (selected) return <SickLeaveCreateDialog workerId={selected.radnik_id} workerName={selected.worker_name} siteId={selected.gradiliste_id} onClose={() => { setSelected(null); onClose?.(); }} onChanged={async () => { resource.reload(); onChanged?.(); }} />;
  return onClose ? <Dialog title="Prijavi bolovanje — odaberi radnika" onClose={onClose}>{content}</Dialog> : content;
}
